<a href="" data-ng-click="dashboard.gotoAccount(account.accountId)">
    <div class="credit-master-account-widget p-15 app-white-card  dashboard-widget-item">
        <h4>{{account.accountDescription}}</h4>
        <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>
        <p class="m-b-0">{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>
    </div>
</a>
<uib-progressbar style="height:10px;" value="55"></uib-progressbar>